import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ConstantService } from 'src/app/service/constant.service';

@Component({
  selector: 'app-bottomsheet-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bottomsheet-modal.component.html',
  styleUrls: ['./bottomsheet-modal.component.less']
})
export class BottomsheetModalComponent {
  showInvalidDiv: boolean;
  showSuccessDiv: boolean;
  showPendingDiv: boolean;
  showFailedDiv: boolean;
  showNotLoginDiv: boolean;
  ticketNumber: string;

  constructor(private bottomSheetRef: MatBottomSheetRef<BottomsheetModalComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    private constantService: ConstantService
  ) { }

  ngOnInit(): void {
    this.checkAndShowDiv();
    this.ticketNumber = this.data.ticketNumber;
  }

  checkAndShowDiv(): void {
    try {
      if(this.data.message == this.constantService.bottomSheetModalMessages.invalid){
        this.showInvalidDiv = true;
      } else if(this.data.message == this.constantService.bottomSheetModalMessages.success){
        this.showSuccessDiv = true;
      } else if (this.data.message == this.constantService.bottomSheetModalMessages.pending) {
        this.showPendingDiv = true;
      } else if(this.data.message == this.constantService.bottomSheetModalMessages.failed) {
        this.showFailedDiv = true;
      } else if(this.data.message == this.constantService.bottomSheetModalMessages.notLoggedIn) {
        this.showNotLoginDiv = true;
      }
    } catch(e){
      console.log('Error in checkAndShowDiv method - ',e);
    }
  }

  close(): void {
    try {
      this.bottomSheetRef.dismiss();
    } catch (e) {
      console.log('Error in close method - ',e);
    }    
  }

  closeSuccess(): void {
    try {
      this.bottomSheetRef.dismiss();
      this.bottomSheetRef.afterDismissed().subscribe(() => {
        this.router.navigateByUrl('');    
      });
    } catch(e) {
      console.error("Error in closeSuccess method - ", e);
    }
  }

  Login(): void {
    try {
      window.location.href = this.constantService.webLoginUrl;
    } catch (e) {
      console.log("Error in Login method - ",e);
    }
  }

}
